import { createSlice } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@services/state/store';
import React from 'react';

export type SavingState = {
  saving: boolean;
};

const slice = createSlice({
  name: 'saving',
  initialState: {
    saving: false,
  } as SavingState,
  reducers: {
    setSaving: (state, action) => {
      state.saving = action.payload;
    },
  },
});

export const savingActions = slice.actions;
export const savingReducer = slice.reducer;

export const useSaving = (): [boolean, (saving: boolean) => void] => {
  const state = useAppSelector((state) => state.saving);
  const dispatch = useAppDispatch();

  const setSaving = React.useCallback((saving: boolean) => {
    dispatch(savingActions.setSaving(saving));
  }, []);

  return [state.saving, setSaving];
};
